/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-pages-cms-cookie-policy',
    templateUrl: './cookie-policy.component.html',
})
export class PagesCmsCookiePolicyComponent { }
